import { render, staticRenderFns } from "./SupplierOverviewTable.vue?vue&type=template&id=58cbd94e&scoped=true"
import script from "./SupplierOverviewTable.vue?vue&type=script&lang=ts"
export * from "./SupplierOverviewTable.vue?vue&type=script&lang=ts"
import style0 from "./SupplierOverviewTable.vue?vue&type=style&index=0&id=58cbd94e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cbd94e",
  null
  
)

export default component.exports